.chat-preview-container {
    display: flex;
    flex-direction: column;
    width: 305px;
    height: 400px;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
}

.chat-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.chat-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    padding: 12px;
    background-color: var(--white);
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    gap: 12px;
}

.icon-avatar-container {
    display: flex;
    justify-content: flex-end;
    /* match width of chat-preview-container */
    width: 305px;
}

.popover-text {
    max-width: 150px;
    padding: 16px;
}

.footer-wrapper {
    box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.15);
    background-color: var(--white);
}

.footer-input {
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
}

.footer-powered-by {
    composes: footer-input;
    padding: 16px 16px 8px;
}

.footer-submit-button {
    display: flex;
    background-color: var(--blue);
    color: var(--white);
    margin: 16px 32px 16px 32px;
    padding: 8px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
}

.chat-bubble {
    padding: 8px;
    border-radius: 8px;
    width: fit-content;
    text-align: left;
}

.chat-bubble--incoming {
    composes: chat-bubble;
    background-color: var(--button-secondary);
}

.chat-bubble--outgoing {
    composes: chat-bubble;
    background-color: var(--off-white);
}

.chat-bubble--suggestion {
    composes: chat-bubble;
    background-color: var(--white);
}

.offline-form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border: 1px solid var(--border-color);
    border-radius: 3px;
    background-color: var(--off-white);
    height: 160px;
    margin-bottom: 16px;
}

.online-form-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    border: 1px solid var(--off-white-dk);
    border-radius: 8px;
    background-color: var(--white);
}

.form-field {
    display: flex;
    width: 90%;
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    padding: 4px;
    color: var(--grey-xlt);
}

.icon-avatar {
    font-size: 30px;
}

.form-button {
    background-color: var(--button-secondary);
    padding: 8px;
    border-radius: 3px;
}
